/**
 * Customize Gravity Forms behavior with our own JS.
 */
export default () => {

  // [target] attribute should narrow things to only AJAX forms
  $(document).on('submit', '.gform_wrapper form[target]', () => {
    window.aauwLoading.addEvent('gf-ajax');
  });

  // gform_confirmation_loaded event is fired by (only) AJAX forms
  // gform_page_loaded is the only javascript event fired when an AJAX form
  // submission is returned with validation problems. While this is not cleanly
  // associated with just AJAX submission rejection (thanks GF), in practice its
  // use here should rarely to never overlap with other events that trigger it.
  $(document).on('gform_confirmation_loaded gform_page_loaded', () => {
    window.aauwLoading.endEvent('gf-ajax');
  });

};
